import { render, staticRenderFns } from "./IncidentReport.vue?vue&type=template&id=c0c8552e"
import script from "./IncidentReport.vue?vue&type=script&lang=js"
export * from "./IncidentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports